"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnavailableChip = exports.ErrorChip = exports.Chip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireWildcard(require("./theme"));
var _constants = require("../../utils/constants");
var _icons = require("../../../azalea/icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// eslint-disable-next-line no-restricted-imports

var ThemeableChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var theme = props.theme,
    onRemove = props.onRemove;
  var ChipTextComponent = theme.typography;
  return /*#__PURE__*/React.createElement(ChipWrapper, (0, _extends2["default"])({
    ref: ref,
    $theme: theme,
    $onRemove: onRemove
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(ChipTextComponent, null, props.text), onRemove && /*#__PURE__*/React.createElement(CloseIconWrapper, {
    onClick: props.onRemove,
    "data-provides": "remove-chip"
  }, /*#__PURE__*/React.createElement(_icons.XIcon, {
    size: '16px'
  })));
});
ThemeableChip.displayName = 'ThemeableChip';
var CloseIconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "chips__CloseIconWrapper"
})(["svg{background:", ";path{fill:", ";}&:hover{border-radius:50%;cursor:pointer;background:", ";path{fill:", ";}}}"], _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme["default"].color, _theme.CloseIconTheme.hover.backgroundColor, _theme.CloseIconTheme.hover.color);
var ChipWrapper = _styledComponents["default"].span.attrs(function (props) {
  return {
    'data-provides': props['data-provides'] || 'chip-wrapper',
    title: props.title || props.text
  };
}).withConfig({
  displayName: "chips__ChipWrapper"
})(["display:inline-flex;align-items:center;justify-content:space-between;gap:0.25rem;height:1.5rem;background:", ";border:1px solid ", ";border-radius:5px;box-sizing:border-box;line-height:100%;padding-left:0.5rem;padding-top:0.125rem;padding-bottom:0.125rem;padding-right:", "rem;white-space:nowrap;&:hover{border:1px solid ", ";}"], function (_ref) {
  var $theme = _ref.$theme;
  return $theme.backgroundColor;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.borderColor;
}, function (props) {
  return props.$onRemove ? "0.25" : "0.5";
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.hoverBorderColor;
});
var Chip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"]["default"],
    ref: ref
  }));
});
exports.Chip = Chip;
Chip.displayName = 'Chip';
Chip.defaultProps = {
  'data-provides': 'default-chip'
};
var ErrorChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].error,
    ref: ref
  }));
});
exports.ErrorChip = ErrorChip;
ErrorChip.displayName = 'ErrorChip';
ErrorChip.defaultProps = {
  'data-provides': 'error-chip'
};
var UnavailableChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].unavailable,
    ref: ref
  }));
});
exports.UnavailableChip = UnavailableChip;
UnavailableChip.displayName = 'UnavailableChip';
UnavailableChip.defaultProps = {
  'data-provides': 'unavailable-chip'
};